import { render, staticRenderFns } from "./RouterTeamView.vue?vue&type=template&id=b4775292&scoped=true"
import script from "./RouterTeamView.vue?vue&type=script&lang=js"
export * from "./RouterTeamView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4775292",
  null
  
)

export default component.exports